import { NavItem, Select } from '@billy/design-system'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { RecurringInvoiceDuration } from '@features/recurringInvoices/enums/recurringInvoiceDuration'

import { useRecurringInvoiceForm } from '../../../../../../../../contexts/recurringInvoiceFormContext'

export const Duration = () => {
  const { t } = useTranslation()
  const { recurringInvoiceForm } = useRecurringInvoiceForm()

  const { FormItem } = recurringInvoiceForm

  const durationOptionLabels = useMemo(
    () => ({
      [RecurringInvoiceDuration.Indefinite]: t(
        'external_invoices.editor.form.recurring_invoice_settings.field.duration.option.no_end_date',
      ),
      [RecurringInvoiceDuration.Repeat]: t(
        'external_invoices.editor.form.recurring_invoice_settings.field.duration.option.ends_after',
      ),
    }),
    [t],
  )

  const items: NavItem<RecurringInvoiceDuration>[] = useMemo(() => {
    return Object.values(RecurringInvoiceDuration).map((duration) => ({
      id: duration,
      value: duration,
      children: durationOptionLabels[duration] || duration,
    }))
  }, [durationOptionLabels])

  return (
    <FormItem
      name="duration"
      label={t('external_invoices.editor.form.recurring_invoice_settings.field.duration.label')}
      render={({ field: { onChange, value, ...props } }) => (
        <Select {...props} dropdownSize="fitTrigger" items={items} onSelect={onChange} selectedId={value} size="sm" />
      )}
    />
  )
}
